import { CSS3DObject } from "three/examples/jsm/renderers/CSS3DRenderer";

/* IFRAME CODE EXAMPLE
    <iframe
      style="border: 0; width: 350px; height: 621px;"
      src="[SRC]" seamless
    >
        <a
          href="[LINK]"
        >
            Hell-ô bots by Prüflabor Sonor
        </a>
    </iframe>
 */

class PrufIframe {
  constructor(opts) {
    const {iframeData, x, y, z, ry} = opts
    const div = document.createElement( 'div' );
    div.style.width = iframeData.style.width;
    div.style.height = iframeData.style.height;
    div.style.backgroundColor = 'transparent';
  
    const iframe = document.createElement( 'iframe' );
    iframe.style.width = iframeData.style.width;
    iframe.style.height = iframeData.style.height;
    iframe.style.border = iframeData.style.border;
    iframe.src = encodeURI(iframeData.url);
  
    const link = document.createElement('a');
    link.href = encodeURI(iframeData.link);
    link.text = iframeData.label;
  
    iframe.appendChild( link );
    div.appendChild( iframe );
  
    const object = new CSS3DObject( div );
    object.position.set( x, y, z );
    object.rotation.y = ry;
  
    return object;
  }
}

export {
  PrufIframe
}
